module.exports = __webpack_public_path__ + "static/media/q2.c44e2ddd.md";